import { render, staticRenderFns } from "./DashIntakeNewCases.vue?vue&type=template&id=538ee948&scoped=true&"
import script from "./DashIntakeNewCases.vue?vue&type=script&lang=js&"
export * from "./DashIntakeNewCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ee948",
  null
  
)

export default component.exports